/** Formato di vendita di un miele (250 g, 500 g, 1 kg): prezzo e giacenza stanno qui. */
export interface ProductVariant {
  id: string;
  product_id: string;
  /** Come appare al cliente: "250 g", "1 kg". */
  label: string;
  grams: number;
  price: number;
  original_price: number | null;
  discount_percent: number | null;
  /** Vasetti in vendita sul sito: mai più di `inventory`. */
  stock: number;
  /** Vasetti fisicamente in magazzino (vendite online e fuori sito). */
  inventory: number;
  sort_order: number;
  /** Disattivato: non compare sul sito, resta negli ordini passati. */
  active: boolean;
}

export interface Product {
  id: string;
  created_at: string;
  name: string;
  description: string | null;
  long_description: string | null;
  image_url: string | null;
  category: string | null;
  /** false = nascosto: visibile solo in dashboard, non si può ordinare. */
  active: boolean;
  /** Tutti i formati, anche disattivati, ordinati per sort_order. */
  product_variants: ProductVariant[];
}

/** Colonne da chiedere a Supabase per avere prodotto e formati insieme. */
export const PRODUCT_SELECT = '*, product_variants(*)';

/** Formato in modifica dalla dashboard: `id` assente finché non è salvato. */
export type VariantForm = Omit<ProductVariant, 'id' | 'product_id'> & { id?: string };

export type NewProductForm = {
  name: string;
  description: string | null;
  long_description: string | null;
  image_url: string | null;
  category: string | null;
  variants: VariantForm[];
};
